import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ComponentsModule } from "@components";
import { CustomerDisplayModule } from "@components/customer-display";
import { ProcessPaymentDialogModule } from "@components/process-payment-dialog/process-payment-dialog.module";
import { CreditCardEditDialogModule } from "@components/process-payment-dialog/credit-card-edit-dialog/credit-card-edit-dialog.module";
import { FormsModule } from '@angular/forms';

import { SlickAutoCompleteModule, SlickButtonSpinnerModule, SlickDialogModule, SlickDropDownModule, SlickDatePickerModule, SlickFileDropModule, SlickFileListModule, SlickToastModule, SlickTabsModule, SlickValidationIndicatorModule, SlickGoogleAddressSearchModule, SlickConfirmDialogModule, SlickContainerModule, SlickSearchBarModule, SlickContextMenuModule, SlickGridModule, SlickScreenBlockerModule } from "@slick-components";
import { CustomerEditComponent } from "./customer-edit/customer-edit.component";
import { CustomerProjectProgressComponent } from "./customer-edit/project-progress/customer-project-progress.component";
import { CustomerMultipleAddressesComponent } from "./customer-edit/customer-multiple-addresses/customer-multiple-addresses.component";
import { AssetsModule } from "@components/assets";
import { AiSummaryModule } from "@components/ai-summary";
import { CardEditComponent } from "./customer-edit/payment-info/payment-info-edit.component";
import { ContactEditComponent } from "./customer-edit/contacts/contact-edit.component";
import { ContactEditLayoutComponent } from "./customer-edit/contacts/contact-edit-layout/contact-edit-layout.component";
import { ContactEditDialogComponent } from "./customer-edit/contacts/contact-edit-dialog/contact-edit-dialog.component";
import { CrmEditModule } from "./customer-edit/crm/crm-edit.module";
import { CustomerEditLayoutComponent } from "./customer-edit/customer-edit-layout/customer-edit-layout.component";
import { JobHistoryComponent } from "./customer-edit/job-history/job-history.component";
import { SiteLogEditComponent } from "./customer-edit/site-log/site-log-edit.component";
import { LathamEditComponent } from "./customer-edit/latham-edit/latham-edit.component";
import { CustomerQuickbooksLinkDialogComponent } from "./customer-quickbooks-link-dialog/customer-quickbooks-link-dialog.component";

import { CustomerEditDialogComponent } from "./customer-edit-dialog/customer-edit-dialog.component";
import { ConflictingCustomerDialogModule } from "@shared-components/conflicting-customers-dialog/conflicting-customers-dialog.module";
import { AddressValidationDialogModule } from "@shared-components/address-validation-dialog";

import { SystemLogsModule } from "@components/system-logs"
import { CustomersService } from "@services";
import { InvoicesGridComponent } from "@app/invoices/invoices-page/invoices-grid/invoices-grid.component";
import { LocationsSelectorModule } from "@shared-components/locations-selector";
import { EmailerDialogModule } from "@components/emailer-dialog";
import { BatchPaymentDialogModule } from "@shared-components/batch-payment-dialog";
import { EstimatesGridComponent } from "@app/estimates/estimates-page/estimates-grid/estimates-grid.component";
import { JobsGridComponent } from "@app/jobs/jobs-page/jobs-grid/jobs-grid.component";
import { EquipmentTrackingModule } from '@shared-components/equipment-tracking/equipment-tracking.module';
import { OrendaModule } from '@components/orenda/orenda.module';
import { PaymentsGridComponent } from "@app/payments/payments-page/payments-grid/payments-grid.component";
import { TextChatConversationsModule } from "@app/text-chat/text-chat-components/text-chat-conversations";
import { TextChatMessagesModule } from "@app/text-chat/text-chat-components/text-chat-messages";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ComponentsModule,
		CustomerDisplayModule,
		ProcessPaymentDialogModule,
		CreditCardEditDialogModule,
		SystemLogsModule,
		EquipmentTrackingModule,
		OrendaModule,
		TextChatConversationsModule,
		TextChatMessagesModule,
		CrmEditModule,
		AssetsModule,
		AiSummaryModule,
		ConflictingCustomerDialogModule,
		AddressValidationDialogModule,
		LocationsSelectorModule, EmailerDialogModule, BatchPaymentDialogModule,
		SlickAutoCompleteModule, SlickButtonSpinnerModule, SlickDialogModule, SlickDropDownModule, SlickDatePickerModule, SlickFileDropModule, SlickFileListModule, SlickToastModule, SlickTabsModule, SlickValidationIndicatorModule, SlickGoogleAddressSearchModule, SlickConfirmDialogModule, SlickContainerModule, SlickSearchBarModule, SlickContextMenuModule, SlickGridModule ],
	declarations: [
		CustomerEditComponent,
		CustomerProjectProgressComponent,
		CustomerEditDialogComponent,
		CardEditComponent,
		CustomerMultipleAddressesComponent,
		ContactEditComponent,
		ContactEditDialogComponent,
		CustomerEditLayoutComponent,
		JobHistoryComponent,
		SiteLogEditComponent,
		LathamEditComponent,
        ContactEditLayoutComponent,
		CustomerQuickbooksLinkDialogComponent,
		InvoicesGridComponent,
		EstimatesGridComponent,
		JobsGridComponent,
		PaymentsGridComponent
],
	exports: [CustomerEditComponent, CustomerEditDialogComponent, ContactEditLayoutComponent, CustomerQuickbooksLinkDialogComponent, InvoicesGridComponent, EstimatesGridComponent, JobsGridComponent, PaymentsGridComponent],
	providers: [CustomersService]
})
export class CustomerComponentsModule { }

export { CustomerEditComponent }
export { CustomerEditDialogComponent }
export { ContactEditLayoutComponent }
export { CustomerQuickbooksLinkDialogComponent } 



